import { DimensionValue } from "../cards/dimension-value";

export enum LogicalOperationType {
    And = 0,
    Or,
}

export class DimensionFilterItem {
    public dimensionIndex: number;
    public openBracketsCount: number;
    public closeBracketsCount: number;
    public operationType: LogicalOperationType;
    public not: boolean;
    public value: string;
    public bgColor : string;
    public fontColor : string;
}

export class DimensionsFilter {
    public items: DimensionFilterItem[];

    public static FromDimensionValues(dimVals: DimensionValue[][]): DimensionsFilter {
        let result = new DimensionsFilter();
        result.items = [];

        for (let i = 0; i < dimVals.length; ++i) {
            for (let j = 0; j < dimVals[i].length; ++j) {
                if (dimVals[i][j].isAll) {
                    continue;
                }
                let dimUsedAlready = false;
                for (let k = 0; k < result.items.length; ++k) {
                    if (result.items[k].dimensionIndex == dimVals[i][j].index) {
                        dimUsedAlready = true;
                        break;
                    }
                }
                if (!dimUsedAlready) {
                    let newItem = new DimensionFilterItem();
                    newItem.dimensionIndex = dimVals[i][j].index;
                    newItem.value = dimVals[i][j].value;
                    if (result.items.length > 0) {
                        newItem.operationType = LogicalOperationType.And;
                    }
                    result.items.push(newItem);
                }
            }
        }

        return result;
    }
}